
import { Component, Vue, Watch, Prop } from "vue-property-decorator"
import { namespace, Getter, Mutation, Action } from "vuex-class"

import Guid from "@/scripts/guid"

import User from "@/types/user"
import { CaseDetails, Team, dataTypeByFieldType, DataType, Field } from "@/types"
import { caseColumns, CaseColumn, usersPlusDynamic } from "@/types/caseColumns"
import { InsightSearch, Operator, InsightCalculation, operatorLabels, operatorsByFieldType } from "@/types/insights"
import { dateRangeLabels } from "@/types/insights/dateRange"
import { DateClauseType } from "@/types/insights/dateClauseType"

import vSelect from "vue-select"
// @ts-ignore
import VuePerfectScrollbar from "vue-perfect-scrollbar"

import DataSourceSelect from "@/components/Fields/DataSourceSelect.vue"

import DateTime from "@/components/Fields/DateTime.vue"
import Numeric from "@/components/Fields/Numeric.vue"
import MapSearchBounds from "./MapSearchBounds.vue"
import DateTimeParameterValue from "./DateTimeParameterValue.vue"

import api from "@/services/api"
import { getDefaultSearchClauseParameters, Clause, SearchClauseParameters, DayOfWeek } from "@/types/view"
import { DynamicValue } from "@/types/dynamic"
import { formatDateMixin } from "@/mixins/formatDateMixin"
import { cloneDeep, get } from "lodash"

const caseStore = namespace("cases")

interface ValueItem {
	id: string
	label: string
}

@Component({
	components: {
		"v-select": vSelect,
		"dataSourceSelect": DataSourceSelect
	}
})
export default class ListSelect extends Vue {
	@Prop({ default: null })
	field!: CaseColumn

	@Prop({ default: false, type: Boolean })
	multiple!: boolean

	@Prop({ default: () => null })
	value!: ValueItem | ValueItem[] | null

	private returnedFieldOptions: any[] = []
	private fieldValueKey: string | null = null
	private selectedItem: any = null

	private DataType = DataType;

	public get fieldOptions (): any[] {
		if (this.field && this.field.columnValues && this.fieldValueKey !== this.field.key) {
			this.fieldValueKey = this.field.key
			this.returnedFieldOptions = []
			this.field.columnValues(api).then(options => this.returnedFieldOptions = options)
		}

		if (this.value && !this.selectedItem) {
			this.selectedItem = this.returnedFieldOptions.find(i => i.id === this.value)
		}

		if (this.value && !this.selectedItem) {
			this.setSelectedItemFromValue()
		}

		return this.returnedFieldOptions
	}

	public get fieldDataType (): DataType | null {
		if (!this.field) return null

		return this.field.comparisonType !== undefined
			? this.field.comparisonType
			: this.field.fieldDataType
				? this.field.fieldDataType
				: null
	}

	@Watch("value")
	ValuePropChanged (newValue: string | null) {
		this.setSelectedItemFromValue()
	}

	valueChanged (newValue: string | null) {
		this.$emit("input", newValue)
	}

	valueItemChanged (newValue: any) {
		console.log(newValue)

		if (this.multiple) {
			const newValueList = newValue.map((item: any) => {
				return {
					id: item.id,
					label: this.field.listLabel ? get(item, this.field.listLabel) : item.label
				}
			})

			console.log(newValueList)
			this.$emit("input", newValueList)
		} else {
			const newValueItem = {
				id: newValue.id,
				label: this.field.listLabel ? get(newValue, this.field.listLabel) : newValue.label
			}

			this.$emit("input", newValueItem)
		}
	}

	setSelectedItemFromValue () {
		if (!this.value) {
			this.selectedItem = null
		} else if (this.multiple) {
			const itemDictionary = (this.value as ValueItem[]).toDictionary("id")
			const valueItems = this.returnedFieldOptions.filter(i => itemDictionary[i.id])
			this.selectedItem = valueItems.length > 0 ? valueItems : null
		} else {
			this.selectedItem = this.returnedFieldOptions.find(i => i.id === (this.value as ValueItem).id)
		}
	}
}
